import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import DesignerButton from './DesignerButton';

class PrivacyPolicy extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      email: '',
    };
  }

  handleGoBack = () => {
    this.props.navigate(`/`);
  };

  render() {
    return (
      <div className="PrivacyPolicyHome">
        <h1 className="PrivacyPolicyH1">Word Cup Privacy Policy</h1>

        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBack}></DesignerButton>
        </div>

        <label className="PrivacyPolicyText">
          Effective Date: 27 June2023
          <br />
          <br />
          Introduction <br />
          Welcome to WordCup! This privacy policy ("Policy") explains how we
          collect, use, disclose, and protect your personal information when you
          use our mobile application ("App"). <br />
          <br />
          Information We Collect <br />
          a. Personal Information: We may collect certain personally
          identifiable information that you provide directly to us, such as your
          name, email address, and any other information you voluntarily submit.
          <br />
          <br /> b. Usage Data: We may automatically collect certain information
          about how you use the App, including your device information, IP
          address, browser type, and other usage details.
          <br />
          <br /> Use of Information a. Provide and Improve the App: We may use
          the information we collect to provide and maintain the App, enhance
          its functionality, and improve user experience.
          <br /> b. Communication: We may use your contact information to send
          you administrative and promotional messages, updates, and other
          relevant information about the App. You can opt-out of receiving such
          communications at any time. <br />
          c. Analytics and Aggregated Data: We may analyze and aggregate
          non-personal information for statistical and analytical purposes to
          monitor and improve the App's performance.
          <br />
          <br /> Disclosure of Information <br />
          a. Service Providers: We may share your information with trusted
          third-party service providers who assist us in operating our business,
          providing the App's features, or conducting business-related
          activities on our behalf. These service providers are obligated to
          keep your information confidential and secure.
          <br /> b. Legal Requirements: We may disclose your information if
          required to do so by law or in response to valid requests by public
          authorities (e.g., law enforcement agencies).
          <br />
          <br /> Data Security <br />
          We implement reasonable security measures to protect your information
          from unauthorized access, use, or disclosure. However, no data
          transmission over the internet or storage system can be guaranteed as
          100% secure. <br />
          <br />
          Children's Privacy
          <br /> Our App is not intended for use by children under the age of
          13. We do not knowingly collect personal information from children. If
          you believe we have inadvertently collected information from a child,
          please contact us immediately.
          <br />
          <br /> Changes to the Policy <br />
          We reserve the right to modify this Policy at any time. Any updates
          will be effective upon posting the revised Policy on our App. It is
          your responsibility to review the Policy periodically. <br />
          <br />
          Contact Us <br />
          If you have any questions, concerns, or requests regarding this
          Policy, please contact us at [contact email]. Remember to adapt and
          customize this template to accurately reflect your app's privacy
          practices and comply with relevant laws and regulations.
        </label>
      </div>
    );
  }
}

export default withCookies(PrivacyPolicy);
